import { createStyles, makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    tabPanel: {
      padding: "0 !important",
      margin: "0",
      "& .MuiTable-root": {
        "& .MuiTableRow-root": {
          "& .MuiTableCell-root": {
            "& .MuiTableSortLabel-root": {
              "&:hover": {
                color: "#bbdefb"
              }
            },
            "& .MuiTableSortLabel-active": {
              color: "#bbdefb",
              "& .MuiTableSortLabel-icon": {
                color: "#bbdefb"
              }
            }
          },
          "&:nth-child(even)": {
            backgroundColor: "rgba(5,89,141, 0.1)"
          }
        }
      }
    },
    topHeader: {
      borderBottom: "1px solid #9c9c9c",
      fontSize: "0.5 rem"
    },
    tabHeader: {
      backgroundColor: "#05598d"
    },
    tabEntry: {
      color: "#fff",
      textTransform: "none"
    },
    indicator: {
      backgroundColor: "#e3e9ff"
    }
  })
);
